import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ThankYou from "@/pages/ThankYou";
const ThankYouRoute = () => <ThankYou variant="contact" />;

export const Route = createFileRoute("/zh-cn/thank-you/contact")({
  head: () => buildRouteHead("/zh-cn/thank-you/contact"),
  component: ThankYouRoute,
});

